import { AbstractControl } from '@angular/forms';

export class CustomFormValidators {
  public static isAlphanumeric(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value) {
      const nonAlphanumericRegex = /[^a-zA-Z0-9-]/g;
      if (nonAlphanumericRegex.test(control.value)) {
        return {
          alphanumeric: true
        };
      }
    }

    return null;
  }

  public static email(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value) {

      // Regexp compliant with rfc5322 specification https://www.ietf.org/rfc/rfc5322.txt and https://emailregex.com/
      // eslint-disable-next-line max-len, no-control-regex
      const validEmailRegex = /(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/g;
      if (!validEmailRegex.test(control.value)) {
        return {
          email: true
        };
      }
    }

    return null;
  }
}
